<template>
  <v-app>
    <div class="container-fluid">

      <div class="row">
        <div class="col-md-12">
          <div class="card">

            <v-container fluid>
                <v-card-title>
                  <v-btn :to="{name: 'tickets.create'}" rounded color="#308BB0" class="text-white">
                    <v-icon>mdi-plus</v-icon>
                    ارسال تیکت جدید
                  </v-btn>
                  <v-spacer/>
                  {{ $route.meta.title }}
                  <v-spacer/>
                  <v-btn :loading="loading" @click="reload" color="primary" rounded
                         class="text-white">
                    <v-icon>mdi-refresh</v-icon>
                    به روزرسانی
                  </v-btn>

                </v-card-title>
                <v-divider/>

                <div class="row">

                  <div class="col-md-12 p-5">


                    <data-table
                        :data="data"
                        :columns="columns"
                        class="p-2"
                        :debounce-delay="5000"
                        :translate="translate"
                        :per-page="[10, 25, 50, 100, 400]"
                        @on-table-props-changed="reloadTable"
                    >
                    </data-table>

                  </div>
                </div>

<!--              </v-card>-->

            </v-container>
          </div>
        </div>
      </div>

    </div>
    <v-dialog
        transition="dialog-bottom-transition"
        max-width="600"
        v-model="dialog"
    >

      <template v-slot:default="dialog">
        <v-card>
          <v-toolbar
              color="primary"
              dark
          > <div class="text-h3 text-center">{{item.title}}</div></v-toolbar>
          <v-card-text>
            <div class="text-h5 pt-5" v-html="item.text"></div>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn
                text
                color="pink"
                dark
                @click="dialog.value = false"
            >بستن</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

  </v-app>
</template>
<script >
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import Button from "@/view/pages/Button";
import interActionBtn from "@/view/pages/tickets/interActionBtn";
import userLinkBtn from "@/view/pages/admin/adminNotifications/userLinkBtn";

export default {
  data() {
    return {
      loading: false,
      data: {},
      dialog: false,
      item: null,
      url:'myTickets',
      columns:[
        {
          name: 'show',
          label: '',
          component: Button,
          handler: this.actions,
          event: 'action',
          meta: {
            permission_prefix: 'notification_',
            buttons: [
              {
                name: 'show',
                label: 'نمایش',
                icon: 'comment',
                class:'btn-outline-info',
              }
            ]
          }
        },


        {
          name: 'id',
          label: 'شناسه',
          orderable: true,
        },
        {
          label: 'عنوان',
          name: 'title',
          orderable: true,
        },
        {
          label: 'وضعیت',
          name: 'status',
          orderable: true,
          transform: (value) => {
            return this.ticketStatus(value.data.status);
          }
        },

        {
          name: 'updated_at',
          label: 'آخرین به روزرسانی',
          orderable: true,
          transform: (value) => {
            return this.$options.filters.longDate(value.data.updated_at);
          }
        },

        {
          name: 'actions',
          label: 'بازخورد',
          component: interActionBtn,
          handler: this.actions,
          event: 'action',
          meta: {
            permission_prefix: 'notification_',
            // buttons: [
            //   {
            //     name: 'show',
            //     label: 'نمایش',
            //     icon: 'eye',
            //     class:'btn-outline-info',
            //   }
            // ]
          }
        }
      ],
      translate: {
        nextButton: 'بعدی',
        previousButton: 'قبلی',
        rowsPerPageText: 'تعداد در صفحه',
        noDataText: 'داده ای برای نمایش وجود ندارد',
        placeholderSearch: 'جستجو',
      },
      tableProps: {
        search: '',
        length: 10,
        column: 'id',
        dir: 'desc',
      },
    }
  },
  methods: {
    reloadTable(tableProps) {
      this.getNotifications(this.url, tableProps);
    },
    getNotifications(url= this.url, query= this.tableProps) {
      this.loading = true;
      this.requestApiGet(url, query)
        .then(response => {
          this.data = response.data;
          this.loading = false;
        })
        .catch(error => {
          console.log(error)
        });
    },
    reload() {
      this.getNotifications(this.url, this.tableProps);
    },

    actions(data, type) {
      this[type](data);
    },

    show(data) {
      this.$router.push({name: 'tickets.edit', params: {id: data.id}});
    },
    edit(data) {
      this.$router.push({name: 'adminTickets.edit', params: {id: data.id}});
    },


    ticketStatus(data) {
      if (data === 'open') {
        return 'باز';
      } else if (data === 'closed') {
        return 'بسته';
      } else if (data === 'notification') {
        return ' اطلاع رسانی';
      } else if (data === 'push_notification') {
        return  'اطلاع رسانی درون برنامه ای';
      }
    },


    notifyStatus(data) {
      if (data.status === 'pending') {
        return 'در انتظار';
      } else if (data.status === 'sent') {
        return 'ارسال شده';
      } else if (data.status === 'denied') {
        return 'ارسال نشده';
      } else if (data.status === 'payed') {
        return 'پرداخت شده';
      } else if (data.status === 'approved') {
        return 'تایید شده';
      }
    }
  },
  created() {
    this.getNotifications(this.url);
    this.$store.dispatch(SET_BREADCRUMB, [{title: this.$route.meta.title}]);
  },
}
</script>